export default __webpack_public_path__ + "static/media/femme-fatale.441afdf5.svg";